import { Suspense, useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Grid,
  Heading,
  Spinner,
  Layout,
  Button,
} from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, {
  ChevronLeftDoubleIcon,
  ChevronRightDoubleIcon,
} from '@enterprise-ui/icons'
import { useFirefly } from '../../resources/useAnalytics'

import { useMain } from '../main/useMain'
import { SearchRail } from './leftRail'
import { SearchGrid } from './grid'
import { useSearchPage } from './useSearchPage'

import '@enterprise-ui/canvas-ui-css-autocomplete'
import 'ag-grid-community/styles/ag-grid.css' // Core CSS
import 'ag-grid-community/styles/ag-theme-quartz.css'

import '../../styles/search.scss'
import '../../styles/customStyles.scss'

const Search = (props) => {
  const viewTrackedRef = useRef(false)

  const { getUserProfile, loading } = useMain()
  const { isCollapsed, setIsCollapsed, handleParentStore } = useSearchPage()
  const { handleTrackViewEvent } = useFirefly()

  useEffect(() => {
    if (props && props?.parentStore) {
      handleParentStore(props.parentStore)
    }
  }, [props, handleParentStore]) // ✅ only run when parentStore changes

  useEffect(() => {
    if (viewTrackedRef.current) return
    viewTrackedRef.current = true
    handleTrackViewEvent('Search MFE - Home', window.location.pathname)
  }, [handleTrackViewEvent])

  return (
    <Suspense fallback={<Spinner />}>
      <Layout.Body
        data-testid="dashboard-page"
        includeRail
        className="layout-body-section"
      >
        <Helmet defaultTitle="LaunchPad: Search" />
        {loading || !getUserProfile ? (
          <Grid.Container>
            <Grid.Item>
              <Heading size={4}>
                <Spinner size="inline" /> Loading search item data ...
              </Heading>
            </Grid.Item>
          </Grid.Container>
        ) : (
          <div
            className={`search-page-layout ${isCollapsed ? 'collapsed' : ''}`}
          >
            <div className="top-left search-rail">
              <SearchRail
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
              />
            </div>
            <div
              className={`bottom-left expand-collapse-btn ${isCollapsed ? 'collapsed' : 'expanded'}`}
            >
              <Button
                iconOnly
                type="ghost"
                aria-label="Menu Icon"
                onClick={() => setIsCollapsed(!isCollapsed)}
                className=""
              >
                <EnterpriseIcon
                  icon={
                    !isCollapsed
                      ? ChevronLeftDoubleIcon
                      : ChevronRightDoubleIcon
                  }
                />
              </Button>
            </div>
            <SearchGrid />
          </div>
        )}
      </Layout.Body>
    </Suspense>
  )
}

export default Search
